export default (initialState = {}) => {
  return () => {
    return {
      // tax_settings: {
      //   _id: null,
      //   name: "",
      // },
      tax_settings: {
        _id: null,
        code: "",
        percentage: 0,
        type: "",
        name: "",
        applicable: [],
        ...initialState,
      },
      min_net_sales_margin: 1,
    };
  };
};
